import {
  ButtonWithPopover,
  ButtonWithPopoverProps,
} from '@/components/form/baseInputs/Button/ButtonWithPopover';
import { PlusIcon } from '@/components/icons/PlusIcon';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useModalState } from '@/hooks/useModalState';
import { GenerateFromDocumentsModal } from '@/modules/aiOnboarding/components/GenerateFromDocumentsModal';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { ClientOrganizationModal } from '@/modules/clientOrganizations/ClientOrganizationModal';
import { ClientProfileSideDrawer } from '@/modules/clientProfiles/ClientProfileForm/ClientProfileModal';

interface AddIndividualOrOrganizationProps
  extends Partial<ButtonWithPopoverProps> {
  householdId: string;
}

export function AddIndividualOrOrganization({
  householdId,
  ...buttonProps
}: AddIndividualOrOrganizationProps) {
  const canEdit = useCanEditHouseholdData();

  const [
    clientProfileModalState,
    {
      openModal: openClientProfileModal,
      setModalIsOpen: setClientProfileModalIsOpen,
    },
  ] = useModalState();
  const [
    clientOrganizationModalState,
    {
      openModal: openClientOrganizationModal,
      setModalIsOpen: setClientOrganizationModalOpen,
    },
  ] = useModalState();
  const [
    { isModalOpen: isGenerateFromDocumentsModalOpen },
    { setModalIsOpen: setIsGenerateFromDocumentsModalOpen },
  ] = useModalState();

  if (!canEdit) {
    return null;
  }

  return (
    <>
      {clientProfileModalState.isModalOpen && (
        <ClientProfileSideDrawer
          isOpen={clientProfileModalState.isModalOpen}
          setIsOpen={setClientProfileModalIsOpen}
          householdId={householdId}
          clientProfileId={null}
          clientProfileTypeDisplay="individual"
          isPrimary={false}
          forceGrantorIfNoClientProfileId={false}
          allowDelete={true}
        />
      )}
      {clientOrganizationModalState.isModalOpen && (
        <ClientOrganizationModal
          isOpen={clientOrganizationModalState.isModalOpen}
          setIsOpen={setClientOrganizationModalOpen}
          organizationId={null}
          householdId={householdId}
        />
      )}
      {isGenerateFromDocumentsModalOpen && (
        <GenerateFromDocumentsModal
          isOpen={isGenerateFromDocumentsModalOpen}
          onClose={() => setIsGenerateFromDocumentsModalOpen(false)}
        />
      )}
      <ButtonWithPopover
        label="Add"
        variant="primary"
        size="sm"
        popperVariant="menuBelow"
        startIcon={PlusIcon}
        iconProps={{ size: 16 }}
        {...buttonProps}
      >
        <MenuItem
          label="New individual"
          onClick={() => openClientProfileModal()}
        />
        <MenuItem
          label="New organization"
          onClick={() => openClientOrganizationModal()}
        />
      </ButtonWithPopover>
    </>
  );
}
